import { useEffect, useRef, useState } from "react";
import { api, pesanGalat } from "../../lib/api";

export default function LokasiAwalRingkas({ onSaved }) {
  const [nama, setNama] = useState("Toko Utama");
  const [cabang, setCabang] = useState("");
  const [options, setOptions] = useState([]);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [uncertain, setUncertain] = useState(false);
  const saving = useRef(false);
  useEffect(() => { api.get("/inventory/cabang-options").then(r => { setOptions(r.data.items); if (r.data.items.length === 1) setCabang(r.data.items[0]); }).catch(e => setError(pesanGalat(e))); }, []);
  const save = async e => {
    e.preventDefault();
    if (saving.current || uncertain) return;
    saving.current = true; setBusy(true); setError("");
    try { await api.post("/inventory/warehouses", { nama: nama.trim(), tipe: "toko", cabang, allowed_branches: [cabang], all_branches: false }); onSaved(); }
    catch (err) { setError(pesanGalat(err)); if (!err.response) setUncertain(true); }
    finally { saving.current = false; setBusy(false); }
  };
  return <form onSubmit={save} className="rounded-2xl border border-amber-200 bg-amber-50 p-4" data-testid="inv-lokasi-awal">
    <h2 className="font-semibold">Siapkan lokasi penyimpanan pertama</h2><p className="mt-1 text-sm">Cukup sekali agar barang masuk tercatat di toko yang benar.</p>
    <fieldset disabled={busy || uncertain} className="mt-3 flex flex-wrap items-end gap-3">
      <label className="text-sm">Nama lokasi<input required className="mt-1 block min-h-11 rounded-xl border bg-white px-3" value={nama} onChange={e => setNama(e.target.value)} /></label>
      <label className="text-sm">Cabang<select required className="mt-1 block min-h-11 rounded-xl border bg-white px-3" value={cabang} onChange={e => setCabang(e.target.value)}><option value="">Pilih cabang</option>{options.map(x => <option key={x}>{x}</option>)}</select></label>
      <button disabled={!nama.trim() || !cabang} className="min-h-11 rounded-xl bg-slate-900 px-4 text-sm font-semibold text-white disabled:opacity-40">{busy ? "Menyimpan…" : "Simpan lokasi"}</button>
    </fieldset>
    {error && <p className="mt-2 text-sm text-rose-700" role="alert">{error}</p>}
    {uncertain && <p className="mt-2 text-sm">Status penyimpanan belum pasti. Muat ulang Inventory untuk memeriksa lokasinya sebelum mencoba lagi.</p>}
  </form>;
}
